import { MutationFunction } from '@tanstack/react-query';
import { isNil } from 'lodash-es';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { OneMutationService } from 'types/services/services';

/**
 * Create a tanstack query mutation function from a mutation service.
 * @param service the mutation service
 * @param dispatch the legacy redux dispatch
 * @returns the tanstack query mutation function
 */
const mutationServiceToTQMutationFunction =
  <Data, Params = undefined>(service: OneMutationService<Data, Params>, dispatch: Dispatch<AnyAction>): MutationFunction<Data, Params> =>
  async (params) => {
    // call the  mutation service
    const result = service.mutation(params);

    // Redux legacy action in order to ensure consitency
    const { legacyService } = service;

    if (!isNil(legacyService) && !isNil(dispatch)) {
      legacyService.forEach((action) => {
        dispatch(action);
      });
    }

    return result;
  };

export default mutationServiceToTQMutationFunction;
